import { execAdminForm } from '../utils';

interface ScheduleCatalogUploadVariables {
  partnerCode: string;
  source?: string;
  sourcePartnerCode?: string;
  useExistingUpload?: boolean;
  scheduleAt?: string;
  timezone?: string;
  totalRowCount?: number;
}

interface ScheduleCatalogUploadResponse {
  scheduleCatalogUpload: {
    result: boolean;
  };
}

const SCHEDULE_CATALOG_UPLOAD_MUTATION = `
  mutation scheduleCatalogUpload(
    $partnerCode: String
    $source: String
    $sourcePartnerCode: String
    $useExistingUpload: Boolean
    $scheduleAt: String
    $timezone: String
    $totalRowCount: Int
  ) {
    scheduleCatalogUpload(
      partnerCode: $partnerCode
      source: $source
      sourcePartnerCode: $sourcePartnerCode
      useExistingUpload: $useExistingUpload
      scheduleAt: $scheduleAt
      timezone: $timezone
      totalRowCount: $totalRowCount
    ) {
      result
    }
  }
`;

export const scheduleCatalogUpload = async (
  variables: ScheduleCatalogUploadVariables,
  file: File,
): Promise<ScheduleCatalogUploadResponse> => {
  return execAdminForm<ScheduleCatalogUploadVariables, ScheduleCatalogUploadResponse>(
    SCHEDULE_CATALOG_UPLOAD_MUTATION,
    variables,
    { file },
  );
};
